import { FileData } from '@/shared/interface/userRegistrationData.ts';
import { Gender, PhotoState, VideoState } from '@/enums/apiEnums.ts';

export enum PhotoKind {
  KIND_PRIMARY = 'KIND_PRIMARY',
  KIND_THUMB = 'KIND_THUMB'
}

export enum VideoKind {
  KIND_POSTER = 'KIND_POSTER',
  KIND_VIDEO = 'KIND_VIDEO'
}

export interface PhotoShowcase {
  [PhotoKind.KIND_PRIMARY]: string;
  [PhotoKind.KIND_THUMB]: string;
}

export interface PhotoVariants {
  url: string;
  kind: PhotoKind;
  thumbhash: string;
}

export interface ServerPhotoV2 {
  hid: string;
  state: PhotoState;
  variants: PhotoVariants[];
}

export interface VideoVariants {
  url: string;
  kind: VideoKind;
  thumbhash?: string;
}

export interface ServerVideoV2 {
  hid: string;
  in_review?: boolean;
  state: VideoState;
  variants: VideoVariants[];
}

export type UserDataFields = {
  name: string;
  about_me: string;
  gender: Gender;
  birthday: string;
  age: number;
  locale?: string;
  photos: Array<FileData>;
  photosOrigin: Array<File>;
  selfie?: FileData;
};

export type UserSelfieProps = {
  selfie?: FileData;
  updateFields: (fields: Partial<{ selfie?: FileData }>) => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
};
